import React from "react";
import DateTimeRange from "../../columnFilters/DateTime/datetime";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import appConstant from "../../../../appConstants";
import DateFnsUtils from "@date-io/date-fns";
import { parse,format, isValid as isDateTimeValid, isAfter, isSameMinute} from "date-fns";

class DateTimeRangeEditor extends React.Component {
  constructor(props) {
    super(props);
    this.dateType =  this.props.column.colDef.cellEditorParams.DATETYPE || appConstant.DATETYPES.YEARDATETIME;
    const {startDateTime, endDateTime} = this.getIntitialDates();   
    this.state = {
      startDateTime: startDateTime,
      endDateTime: endDateTime,
    };
    this.inputRef = React.createRef();
  }

  getIntitialDates = () =>{
    if(this.props.value){
      const [startDateString, endDateString] = this.props.value.split(this.dateType.intervalSeperator).map(datestring => datestring.trim())
      return {
        startDateTime: parse(startDateString,this.dateType.format, new Date()),
        endDateTime:parse(endDateString,this.dateType.format, new Date()),
      }
    } 
    return {
      startDateTime: null,
      endDateTime: null
    }
  }

  getValue = () => {
    const { startDateTime, endDateTime } = this.state;
    if(!startDateTime && !endDateTime){
      return null;
    }
    if(isDateTimeValid(startDateTime) && isDateTimeValid(endDateTime) && (isAfter(endDateTime, startDateTime) || isSameMinute(endDateTime, startDateTime))){
      return  [format(startDateTime, appConstant.DATETYPES.YEARDATETIME.format),format(endDateTime, appConstant.DATETYPES.YEARDATETIME.format)].join(this.dateType.intervalSeperator)
    }
    return  "Invalid Date Time"
  };

  isPopup = () => {
    return true;
  };

  onStartDateChange = (value) => {
    this.setState({
      startDateTime: value,
    });
  };
  onEndDateChange = (value) => {
    this.setState({
      endDateTime: value,
    });
  };

  afterGuiAttached() {
    if( this.inputRef?.current){
      this.inputRef.current.focus();
    }
  }

  render() {
    const { startDateTime, endDateTime } = this.state;
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateTimeRange
          inputRef={this.inputRef}
          mode="horizontal"
          dateType={this.dateType}
          startDateTime={startDateTime}
          endDateTime={endDateTime}
          startDateChanged={this.onStartDateChange}
          endDateChanged={this.onEndDateChange}
        />
      </MuiPickersUtilsProvider>
    );
  }
}

export default DateTimeRangeEditor;
